import {
	IconAtom2Outline18 as Atom,
	IconLockOutline18 as Lock,
} from "nucleo-ui-outline-18"

import { cn } from "@productlane/lib/src/cn"
import { Pill, Tooltip } from "@productlane/ui"

import type { ArticlePillState, ArticleVisibility } from "./article-visibility"
import { getArticlePillState } from "./article-visibility"

const TOOLTIPS: Record<Exclude<ArticlePillState, "none">, string> = {
	draft: "This article is not yet published",
	agent:
		"The Productlane Agent answers customers from this article. It stays off your docs site and out of search.",
	internal:
		"Only the AI Assistant reads this article. Your customers and the Productlane Agent never see it.",
}

export const ArticleStatePill = ({
	article,
	className,
	withTooltip = false,
	hideVisibility = false,
}: {
	article: { published: boolean; visibility: ArticleVisibility }
	className?: string
	withTooltip?: boolean
	// The Agent and Internal nav sections already label every row they hold.
	hideVisibility?: boolean
}) => {
	const state = getArticlePillState(article)
	if (state === "none") return null
	if (state !== "draft" && hideVisibility) return null

	const pill =
		state === "draft" ? (
			<Pill
				size="sm"
				variant="dark-gray"
				border="borderless"
				className={cn("group-hover/item:opacity-0", className)}
			>
				Draft
			</Pill>
		) : state === "agent" ? (
			<Pill
				size="sm"
				variant="default"
				border="borderless"
				Icon={Atom}
				iconClassName="h-2.5 w-2.5"
				className={cn("gap-1", className)}
			>
				Agent
			</Pill>
		) : (
			<Pill
				size="sm"
				variant="red"
				border="borderless"
				Icon={Lock}
				iconClassName="h-2.5 w-2.5"
				className={cn("gap-1", className)}
			>
				Internal
			</Pill>
		)

	if (!withTooltip) return pill

	return <Tooltip label={TOOLTIPS[state]}>{pill}</Tooltip>
}
